import { TableRow } from "@mui/material";
import { FC, useContext } from "react";
import { useNavigate } from "react-router";
import { UserContext } from "../../../../contexts/userContext";
import { tableRow } from "../TableHeading/TableHeading.styles";

const DashboardTableRow: FC<{ redirectUrl: string }> = ({
  children,
  redirectUrl,
}) => {
  const navigate = useNavigate();
  const { isXnft } = useContext(UserContext);

  return (
    <TableRow
      style={tableRow}
      hover
      onClick={(e) => {
        !isXnft && navigate(redirectUrl);
        e.stopPropagation();
      }}
      sx={{
        "&:hover": {
          background: "rgba(255, 255, 255, 0.05) !important",
        },
      }}
    >
      {children}
    </TableRow>
  );
};

export default DashboardTableRow;
